// Supplier Billing Service
// Handles API calls for supplier billing operations

import api from './api';

const supplierBillingService = {
  /**
   * Submit billable hours for a ticket
   */
  async submitBillingHours(ticketId, hoursData) {
    try {
      const response = await api.post(`/api/supplier/helpdesk/tickets/${ticketId}/hours`, hoursData);
      return response.data;
    } catch (error) {
      console.error('Error submitting billing hours:', error);
      throw error;
    }
  },

  /**
   * Get billing hours for a ticket (supplier view)
   */
  async getBillingHours(ticketId) {
    try {
      const response = await api.get(`/api/supplier/helpdesk/tickets/${ticketId}`);
      return response.data?.data?.billing_hours || [];
    } catch (error) {
      console.error('Error fetching billing hours:', error);
      throw error;
    }
  },

  /**
   * Format hours for display
   */
  formatHours(hours) {
    return parseFloat(hours).toFixed(2);
  },

  /**
   * Calculate total hours from billing entries
   */
  calculateTotalHours(billingEntries) {
    if (!Array.isArray(billingEntries)) return 0;
    return billingEntries.reduce((total, entry) => {
      return total + parseFloat(entry.hours_worked || 0);
    }, 0);
  },

  /**
   * Get status badge class
   */
  getStatusBadgeClass(status) {
    switch(status?.toLowerCase()) {
      case 'approved':
        return 'bg-green-100 text-green-800';
      case 'rejected':
        return 'bg-red-100 text-red-800';
      case 'pending':
      default:
        return 'bg-yellow-100 text-yellow-800';
    }
  },

  /**
   * Format date for display
   */
  formatDate(dateString) {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-ZA', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    } catch (e) {
      return dateString;
    }
  },

  /**
   * Format datetime for display
   */
  formatDateTime(dateString) {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      return date.toLocaleString('en-ZA', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (e) {
      return dateString;
    }
  }
};

export default supplierBillingService;
